import React from 'react';
import { Page } from 'react-facebook';

import { Wrapper, Content } from './WidgetFacebookPagePanel.style';

function WidgetFacebookPagePanel({ data = {} }) {
  return (
    <Wrapper>
      {data.href ? (
        <Content>
          <Page
            href={data.href}
            tabs={data.tabs}
            hideCover={data.hideCover}
            height={data.height}
            width={data.width}
            showFacepile={data.showFacepile}
            hideCTA={data.hideCTA}
            smallHeader={data.smallHeader}
            adaptContainerWidth={data.adaptContainerWidth}
          />
        </Content>
      ) : (
        ''
      )}
    </Wrapper>
  );
}

export default WidgetFacebookPagePanel;
